/**
 * Ažuriranje data layera.
 *
 * @see {@link https://home/projects/it/wiki/Data_layer} Dokumentacija data layera
 */

/**
 * Ažurira data layer na osnovu završetka rezervacije neke usluge.
 *
 * Cijena je uvijek u eurima.
 *
 * @param {string} id - Identifikator rezervacije; identifikator je globalni - sadrži prefiks vrste
 * ("PRIVATEACCOMMODATION-" ili "OTHER-").
 * @param {int} priceAmount - Novčani iznos u manjoj jedinici (npr. u lipama ako je valuta HRK)
 * @param {string} priceCurrency - ISO 4217 slovčana oznaka valute (npr. "HRK")
 * @param {string} checkIn - Datum početka korištenja usluge, format je YYYY-MM-DD
 * @param {string} checkOut - Datum kraja korištenja usluge, format je YYYY-MM-DD
 */
export function registerReservationCompleted(
    id,
    priceAmount,
    priceCurrency,
    checkIn,
    checkOut,
) {
    updateDataLayer({
        event: 'reservation_completed',
        reservation: {
            id: String(id),
            parameters: { dates: { checkIn, checkOut } },
            price: { amount: priceAmount, currency: priceCurrency },
        },
    });
}

/**
 * Registrira da je ukupna vrijednost/cijena rezervacije izračunata.
 *
 * Ovo implicitno znači i da su poznati parametri rezervacije.
 *
 * @param {string[]} units - Identifikatori smještajnih jedinica
 * @param {Object} dates - Termin
 * @param {string} dates.checkIn - Datum početka korištenja usluge, format je YYYY-MM-DD
 * @param {string} dates.checkOut - Datum kraja korištenja usluge, format je YYYY-MM-DD
 * @param {Object[]} persons - Broj osoba po smještajnoj jedinici
 * @param {int} persons[].adults - Broj odraslih osoba
 * @param {Object} persons[].children - Broj djece svih uzrasta
 * @param {int} persons[].children.age0To3 - Broj djece starosti do 3 godine (uključujući)
 * @param {int} persons[].children.age4To11 - Broj djece starosti od 4 do 11 godina (uključujući)
 * @param {int} persons[].children.age12To17 - Broj djece starosti od 12 do 17 godina (uključujući)
 * @param {Object} price - Cijena
 * @param {int} price.amount - Novčani iznos u manjoj jedinici (npr. u lipama ako je valuta HRK)
 * @param {string} price.currency - ISO 4217 slovčana oznaka valute (npr. "HRK")
 */
export function registerPrivateAccommodationReservationPriceCalculated(units, dates, persons, price) {
    updateDataLayer({
        event: 'reservation_price_calculated',
        reservation: {
            parameters: { units, dates, persons },
            price,
        },
    });
}

function updateDataLayer(additionalData) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(additionalData);
}

/*
Ako zatreba, na sljedeći način se mogu definirati inicijalne varijable. To se zasad radi mimo ovog modula.

function initializeDataLayer(initialData) {
    window.dataLayer = [initialData];
}
*/
